<template>
  <div class="toolTipWrap">
    <div class="toolTipBtn" @mouseenter="show = !disabled" @mouseleave="show = false">
      <slot></slot>
    </div>
    <div ref="toolTipContent" class="toolTip" v-show="show" :style="{ top: top }" :class="[className]">
      {{ content }}
      <slot name="content"></slot>
      <div class="sanjiao"> </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "LsToolTip",
    props: {
      content: {
        type: [String, Number],
        default: ""
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placement: {
        type: String,
        default: 'left'
      },
    },
    watch: {
      show(newVal) {
        if (newVal && newVal != 0) {
          this.$nextTick(() => {
            this.top = `-${this.$refs.toolTipContent.offsetHeight+10}px`
          })
        }
      }
    },
    computed:{
      className(){
        switch (this.placement) {
          case "left":
            return "toolTipLeft";
          case "center":
            return "toolTipCenter";
          case "right":
            return "toolTipRight";
          default:
            return ''
        }
      }
    },
    data() {
      return {
        show: false,
        top: 0,
      }
    },
    methods: {
    },
  }
</script>
<style lang="less" scoped>
.toolTipWrap{
  display: inline-block;
    position: relative;
  .toolTip {
    /* display: inline-block; */
    white-space:nowrap;
    /* max-width: 100%; */
    padding: 10px;
    position: absolute;
    /* left: 15%; */
    border-radius: 4px;
    height: auto;
    background-color: #000;
    color: #FFFFFF;
    /* animation: fadenum 0.6s; */
    z-index: 1;
    box-sizing: border-box;
    box-shadow: 0px 5px 10px 0px rgba(0,0,0,.1);
    margin: auto;
    font-size: 12px;
    line-height: 20px;
    word-wrap: break-word;
    word-break: normal;
    word-break: break-all;

    .sanjiao {
      position: absolute;
      bottom: -8px;
      width: 0;
      height: 0;
      border-top: 10px solid #000;
      border-right: 7px solid transparent;
      border-left: 7px solid transparent;
    }

    @keyframes fadenum {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }
  }
  .toolTipLeft{
    left: 0;
    .sanjiao{
      left: 10px;
    }
  }
  .toolTipRight{
    right: 0;
    .sanjiao{
      right: 10px;
    }
  }
  .toolTipCenter{
    left: 50%;
    transform: translateX(-50%);
    .sanjiao{
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>